interface PageHeroProps {
  title: string;
  subtitle: string;
}

/** The tinted banner that opens every marketplace step. */
export function PageHero({ title, subtitle }: PageHeroProps) {
  return (
    <section className="sm-panel sm-stack sm-hero">
      <h1 className="sm-type-title">{title}</h1>
      <p className="sm-type-body sm-muted">{subtitle}</p>
    </section>
  );
}
